export default __webpack_public_path__ + "static/media/fdia.8430fa10.svg";